import { defineStore } from "pinia";

export const usePagesStore = defineStore("pagesStore", {
  state: () => {
    return {
      current: <any>null,
      list: [],
    };
  },
  getters: {
    url: (state: any) => {
      return state.current?.url;
    },
    fullPath: (state: any) => {
      return state.current?.url.replace("api.", "");
    },
    activeId: (state: any) => {
      return state.current?.id;
    },
    slug: (state: any) => {
      return state.current?.slug;
    },
    title: (state: any) => {
      return state.current?.title;
    },
    titlePage: (state: any) => {
      return state.current?.titlePage;
    },
    text: (state: any) => {
      return state.current?.text;
    },
    seoTitle: (state: any) => {
      return state.current?.seo?.title;
    },
    seoDescription: (state: any) => {
      return state.current?.seo?.description;
    },
    seoImage: (state: any) => {
      return state.current?.seo?.image;
    },
    blocks: (state: any) => {
      return state.current?.blocks;
    },
  },
  actions: {
    setList(payload: any) {
      this.list = payload;
    },
    setCurrent(payload: any) {
      this.current = payload;
    },
    clearCurrent() {
      this.current = null;
    },
  },
});
